module.exports = __webpack_public_path__ + "img/logo_roxa.722317b5.png";